import { useEffect } from 'react';
import { useProducts } from '../context/ProductsContext';

const ProductSync = () => {
  const { refreshProducts } = useProducts();

  useEffect(() => {
    // Écouter les événements de synchronisation personnalisés
    const handleProductSync = () => {
      console.log('🔄 Synchronisation des produits déclenchée');
      refreshProducts();
    };

    // Écouter les changements dans localStorage pour synchroniser
    const handleStorageChange = (e) => {
      if (e.key === 'farmProducts') {
        console.log('📦 Changement détecté dans localStorage');
        // Délai pour s'assurer que les données sont bien écrites
        setTimeout(() => {
          refreshProducts();
        }, 100);
      }
    };

    // Écouter les changements de localStorage
    window.addEventListener('storage', handleStorageChange);
    
    // Écouter les événements de synchronisation personnalisés
    window.addEventListener('productSync', handleProductSync);

    // Écouter les changements locaux (même fenêtre) - vérification plus fréquente
    const interval = setInterval(() => {
      // Vérifier si localStorage a changé
      const currentData = localStorage.getItem('farmProducts');
      if (currentData) {
        refreshProducts();
      }
    }, 1000); // Vérifier toutes les secondes

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('productSync', handleProductSync);
      clearInterval(interval);
    };
  }, [refreshProducts]);

  // Ce composant ne rend rien, il ne fait que synchroniser
  return null;
};

export default ProductSync;
